import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { SharedService } from '../../services/shared.service';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { startWith, map, delay } from 'rxjs/operators';
import { SettingsService } from '../../services/settings.service';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
  selector: 'app-report-training',
  templateUrl: './report-training.component.html',
  styleUrls: ['./report-training.component.css']
})
export class ReportTrainingComponent implements OnInit {

  @ViewChild('filterUsers', { static: false }) filterUsers: ElementRef;

  constructor(private sharedService: SharedService,
    private reportService: ReportService,
    private settingsService: SettingsService,
    private router: Router) { }

  reportTrainingVos: any[] = [];
  showErrorMessage: boolean;
  showLoadingMessage: boolean = false;
  errorMessage: string;
  userFormControl = new FormControl('');
  filteredUsers: Observable<any[]>;
  searchUser: string;
  trainingVos: any[] = [];
  facilityVos: any[] = [];
  userRoleVos: any[] = [];
  pharmacies: any = [];
  userTrainingProcessStatusVos: any[] = [];
  trainingId: number = 0;
  userFacilityId: number = 0;
  userRoleId: number = 0;
  userTrainingProcessStatusId: number = 0;

  ngOnInit() {
    this.loadFields();
  }

  loadFields() {
    this.sharedService.reloadUserPrivileges();
    setTimeout(() => this.filterUsers.nativeElement.focus(), 500);
    this.searchUser = '';
    this.userFacilityId = this.sharedService.facilityId;
    
    this.showLoadingMessage = true;
    forkJoin([
      this.reportService.getTrainingVos(this.sharedService.pharmacyId),
      this.sharedService.getFacilitiesByPharmacyId(),
      this.settingsService.getRoleItemVoBy(1),
      this.reportService.getReportTrainingVos(this.sharedService.pharmacyId, this.trainingId, this.userFacilityId, this.userRoleId, this.userTrainingProcessStatusId)
    ]).subscribe(
      ([trainings, facilities, roles, reportTrainings]) => {

        if (trainings && Array.isArray(trainings) && trainings.length > 0) {
          this.trainingVos = trainings.sort((a, b) => b.name.localeCompare(a.name));
        }
        this.facilityVos = facilities;
        this.userRoleVos = roles;
        this.reportTrainingVos = reportTrainings;
        this.loadFilteredUsers();
        this.showLoadingMessage = false;
      },
      error => {
        this.showLoadingMessage = false;
      }
    );
  }

  loadReportTrainingVos() {
    this.reportService.getReportTrainingVos(this.sharedService.pharmacyId, this.trainingId, this.userFacilityId, this.userRoleId, this.userTrainingProcessStatusId).subscribe(
      data => {
        this.reportTrainingVos = data;
        this.loadFilteredUsers();
      }
    );
  }

  loadTrainingVos() {
    this.reportService.getTrainingVos(this.sharedService.pharmacyId).subscribe(
      trainings => {
        if (trainings && Array.isArray(trainings) && trainings.length > 0) {
          this.trainingVos = trainings.sort((a, b) => b.name.localeCompare(a.name));
        }
      }
    );
  }

  loadFacilityVos() {
    this.sharedService.getFacilitiesByPharmacyId().subscribe(
      data => {
        this.facilityVos = data;
      }
    );
  }

  loadUserRoleVos() {
    this.settingsService.getRoleItemVoBy(1).subscribe(
      data => {
        this.userRoleVos = data;
      });
  }
  

  loadFilteredUsers() {
    const filtered = this.reportTrainingVos.filter(r =>
      r.userName.toLowerCase().includes(this.searchUser.toLowerCase())
    );

    this.filteredUsers = of(filtered);
  }

  onChangeSelectFilter() {
    this.loadReportTrainingVos();
  }

  openCertificate(userTrainingId: any) {
    var pageTitle = "Training Certificate";
    this.router.navigate([]).then(result => { window.open('report/TrainingCertificate/' + userTrainingId + '/' + pageTitle, '_blank'); });
  }

  exportTableToExcel(fileName: string = 'export.xlsx'): void {
    const element = document.getElementById('table-reports-trainings');
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    worksheet['!cols'] = [
      { wch: 55 }, // A (Name)
      { wch: 55 }, // B (Training Name)
      { wch: 20 }, // C (Status)
      { wch: 20 }, // D (Content)
      { wch: 20 }, // E (Assessment)
      { wch: 20 }, // F (Score)
      { wch: 20 }, // G (Minimum Score)
      { wch: 20 }, // H (Expired Date)
      { wch: 20 }, // I (Certificate Expired)
    ];

    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }
}
